<div class="json-display-container">
  <div
    #jsonHost
    class="json-display"
  ></div>
</div>
